import DiplomaView from './DiplomaView';

export default DiplomaView;
